const SNOOZE_MS = 10 * 60 * 1000;

export { SNOOZE_MS };

/**
 * @param {unknown} value
 * @returns {number | null} ms UTC
 */
export function parseRemindAtValue(value) {
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string") {
    const t = new Date(value).getTime();
    return Number.isFinite(t) ? t : null;
  }
  return null;
}

/**
 * @param {number | null | undefined} ms
 * @returns {string}
 */
export function formatRemindAtForInput(ms) {
  if (ms == null || !Number.isFinite(ms)) {
    return "";
  }
  const d = new Date(ms);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * @param {{ remindAt?: number | null, dismissedForRemindAt?: number | null }} note
 * @param {number} [now]
 */
export function isNoteReminderDue(note, now = Date.now()) {
  if (note?.reminderEnabled === false) {
    return false;
  }
  const remindAt = parseRemindAtValue(note?.remindAt);
  if (remindAt == null || remindAt > now) {
    return false;
  }
  const dismissed = parseRemindAtValue(note?.dismissedForRemindAt);
  return dismissed !== remindAt;
}

/**
 * @param {{ remindAt?: number | null }[]} notes
 * @param {number} [now]
 * @returns {number | null} ms until next fire, or null if none scheduled
 */
export function getNextReminderDelayMs(notes, now = Date.now()) {
  let nextAt = null;
  for (const note of notes) {
    if (note?.reminderEnabled === false) {
      continue;
    }
    const remindAt = parseRemindAtValue(note?.remindAt);
    if (remindAt == null || remindAt <= now) {
      continue;
    }
    if (dismissedBlocks(note, remindAt)) {
      continue;
    }
    if (nextAt == null || remindAt < nextAt) {
      nextAt = remindAt;
    }
  }
  if (nextAt == null) {
    return null;
  }
  return Math.max(0, nextAt - now);
}

function dismissedBlocks(note, remindAt) {
  const dismissed = parseRemindAtValue(note?.dismissedForRemindAt);
  return dismissed === remindAt;
}

/**
 * @param {{ remindAt?: number | null, dismissedForRemindAt?: number | null }[]} notes
 * @param {number} [now]
 */
export function countDueReminders(notes, now = Date.now()) {
  if (!Array.isArray(notes)) {
    return 0;
  }
  return notes.filter((n) => isNoteReminderDue(n, now)).length;
}

/**
 * @param {string} text
 * @param {number} [maxLen]
 */
export function truncateReminderText(text, maxLen = 120) {
  const trimmed = typeof text === "string" ? text.trim() : "";
  if (!trimmed) {
    return "Без текста";
  }
  if (trimmed.length <= maxLen) {
    return trimmed;
  }
  return `${trimmed.slice(0, maxLen - 1)}…`;
}
